import axios from "axios";
import { getItem } from "./LocalStorageManager";
import { jwtDecode } from "jwt-decode";
import { UrlBase } from "./Urls";

const publicFetch = axios.create({
  baseURL: UrlBase.base_url + UrlBase.api_context,
});

const privateFetch = axios.create({
  baseURL: UrlBase.base_url + UrlBase.api_context,
});

privateFetch.interceptors.request.use(
  async (config) => {
    //validate uri to send token
  const { origin } = new URL((config.baseURL ?? "") + (config.url ?? ""));
    const allowedOrigins = [UrlBase.base_url];
  const authInfo = await getItem("authMRPintores") as { tokenInfo?: { access_token?: string } } | null;
  const accessToken = authInfo?.tokenInfo?.access_token;
  if (!accessToken) return config;
  const decodeToken = jwtDecode(accessToken);
  const expiresAt = (decodeToken as any).exp;
  let valid = expiresAt ? new Date().getTime() / 1000 < expiresAt : false;
    //OJO HAY QUE DESCOMENTAR ESTO LUEGO
    if (allowedOrigins.includes(origin) && valid && accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  }
  // error=>{
  //   return Promise.reject(error);
  // }
);

export { publicFetch, privateFetch };
